export default "__VITE_ASSET__Djk2n2by__"